import { PlusOutlined,PlayCircleFilled,MinusOutlined,MessageOutlined,DownOutlined,UpOutlined,LeftOutlined,RightOutlined } from '@ant-design/icons-vue';



  // 导入 Vue 和其他依赖
  import { createApp } from 'vue';
  import App from './App.vue';
  import router from './router';
  import { Input,Space,Row,Button,Col,Tag,Radio,Tabs,InputNumber,Modal,Carousel   } from 'ant-design-vue';
  import { loadAndApplySiteBranding } from './util/siteBranding';
  // 创建 Vue 应用
  const app = createApp(App);
  app.use(Input);
  app.use(Space);
  app.use(Row);
  app.use(Button);
  app.use(Col);
  app.use(Tag);
  app.use(Radio);
  app.use(Tabs);
  app.use(Tabs.TabPane);
  app.use(InputNumber);
  app.use(Modal);
  app.use(Carousel);
  // 使用路由
  app.use(router);
  app.component('PlusOutlined', PlusOutlined);
  app.component('MinusOutlined', MinusOutlined);
  app.component('PlayCircleFilled', PlayCircleFilled);
  app.component('MessageOutlined', MessageOutlined);
  app.component('DownOutlined', DownOutlined);
  app.component('UpOutlined', UpOutlined);
  app.component('LeftOutlined', LeftOutlined);
  app.component('RightOutlined', RightOutlined);


 
  
  // 先应用品牌配置再挂载，减少标题闪烁
  loadAndApplySiteBranding().finally(() => {
    app.mount('#app');
  });
  